class EventGroupViewModel {
  constructor(group, key) {
    this.rowType = 'group';
    this.key = key;
    this.groupKey = group.key;
    this.titleId = group.titleId;
    this.pillStyle = group.pillStyle;
    this.emojiKey = group.emojiKey;
    this.events = [];
  }

  get count() {
    return this.events.length;
  }

  add(event) {
    this.events.push(event);
  }
}

export default EventGroupViewModel;
